import { put, call, all, takeLatest } from 'redux-saga/effects';
import { merge, get, clone, set } from 'lodash';
import { ACTIONBASEINFO } from '../../../actionTypes';
import { APIUSER, APICOMMON } from '../../../actionApi';
import { request } from '../../../utils/request';
import { API } from '../../../env';
function* getCityList(data) {
	let { payload, callback, errorCallback } = data;
	let res = yield call(request, {
		type: 'GET',
		url: API.COMMON_PORXY + APICOMMON.CITY,
		dataParam: payload || {}
	});
	let { ok, status, result = {} } = res || {};
	if (status === 200) {
		yield put({ type: ACTIONBASEINFO.SET_BASEINFO_CITYLIST, payload: result });
		return callback && callback(result);
	}
	return errorCallback && errorCallback(result);
}
function* getBaseInfo(data) {
	let { payload, callback, errorCallback } = data;
	let res = yield call(request, {
		type: 'GET',
		url: API.COMMON_PORXY + APICOMMON.BASEINFODETIAL,
		dataParam: payload || {}
	});
	let { ok, status, result = {} } = res || {};
	if (status === 200) {
		yield put({ type: ACTIONBASEINFO.SET_BASEINFO_DETAIL, payload: result });
		return callback && callback(result);
	}
	return errorCallback && errorCallback(result);
}
function* setBaseInfo(data) {
	let { payload, callback, errorCallback } = data;
	let newpayload = clone(payload);
	if (get(newpayload, 'companyLogo', '')) {
		delete newpayload['companyLogo'];
	}
	let res = yield call(request, {
		type: 'PUT',
		url: API.COMMON_PORXY + APICOMMON.BASEINFODETIAL,
		dataParam: newpayload || {}
	});
	let { ok, status, result = {} } = res || {};
	if (status === 200) {
		console.log('newpayload...', newpayload);
		yield put({ type: ACTIONBASEINFO.SET_BASEINFO_DETAIL, payload: payload });
		return callback && callback(payload, result);
	}
	return errorCallback && errorCallback(result);
}

let baseinfoSaga = [
	takeLatest(ACTIONBASEINFO.FETCH_BASEINFO_CITYLIST, getCityList),
	takeLatest(ACTIONBASEINFO.FETCH_BASEINFO_DETAIL, getBaseInfo),
	takeLatest(ACTIONBASEINFO.FETCH_BASEINFO_SETDETAIL, setBaseInfo)
];
export { baseinfoSaga };
